import { render, staticRenderFns } from "./ItemizeHotel.vue?vue&type=template&id=fad8df68"
import script from "./ItemizeHotel.vue?vue&type=script&lang=js"
export * from "./ItemizeHotel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports